import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { userNeedsPhone } from '../utils/userProfile';

const ProtectedRoute = ({ children, skipPhoneCheck = false }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!skipPhoneCheck && userNeedsPhone(user)) {
    return <Navigate to="/complete-phone" replace />;
  }

  return children;
};

export default ProtectedRoute;
